<template>
  <icon :selected="reallySelected" @click.native="select">
    <slot />
  </icon>
</template>

<script>
import Icon from '@/components/Icon.vue'

export default {
  name: 'IconGroupRadio',

  components: {
    Icon
  },

  inject: [
    'group'
  ],

  props: {
    index: {
      type: null,
      default: undefined
    },

    selected: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    if (this.selected) this.select()
  },

  computed: {
    reallySelected () {
      const { index, group } = this
      return index !== undefined && group.selected === index
    }
  },

  methods: {
    select () {
      this.group.select(this.index)
    }
  },

  watch: {
    selected (selected) {
      if (selected) this.select()
    }
  }
}
</script>
